<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i>
          <span style="margin-left:5px;">历史记录</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <div>
          <el-table 
           min-height="200"  max-height="1000" 
          border 
          v-loading="listLoading" 
          :data="tableData" 
          style="width: 100%"
          >
            <el-table-column  prop="operation_system" label="系统" width = "100" />
            <el-table-column  prop="game_name" label="游戏名称" width = "150" :show-overflow-tooltip="true"/>
            <el-table-column  prop="game_package" label="游戏包名" width = "150" :show-overflow-tooltip="true" />
            <el-table-column  prop="main_game_name" label="主游戏名称" width = "150" :show-overflow-tooltip="true" v-if="main_game_permission" />
            <el-table-column  prop="is_apply" label="互通/不互通 " width = "100"  />
            <el-table-column  prop="app_key" label="appkey" width = "100" />
            <el-table-column  prop="game_link" label="防沉迷链接" width = "150" :show-overflow-tooltip="true" />
            <el-table-column  prop="remark" label="备注" width = "200"  :show-overflow-tooltip="true" />
            <el-table-column  prop="created_at" label="时间点" width = "150" />
            <el-table-column  prop="admin_name" label="上传人" width = "100" />
             <el-table-column label="操作" >
              <template slot-scope="scope">
                <el-button size="mini" type="success" class="link" :data-clipboard-text="scope.row.game_link" @click="copyLink(scope.row)" >复制</el-button>
              </template>
             </el-table-column>
          </el-table>
          <pagination
            v-show="total>0"
            :total="total"
            :page.sync="listQuery.page"
            :limit.sync="listQuery.limit"
            @pagination="viewHistory"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Pagination from "@/components/pagination/index";
import Clipboard from 'clipboard';
import {
    viewHistoryApi
} from "@/api/indulge_link.js";

export default {
  components: { Pagination },
  data() {
      return {
          listQuery:{
            id:"",
            page:1,
            limit:10
          },
          main_game_permission:false,
          total:0,
          tableData:[],
          listLoading:false,
      }
  },
  methods:{
    viewHistory(){
      viewHistoryApi(this.listQuery)
      .then(response =>{
          let array = []
          for(let item of response.data.data.data){
            
              if(item.is_apply == 0){
                item.is_apply = ""
              }
              else if(item.is_apply == 1){
                item.is_apply = "互通"
              }
              else if(item.is_apply == 2){
                item.is_apply = "不互通"
              }
              array.push(item)
          }
          this.tableData = array;
          this.total = response.data.data.total;
          this.main_game_permission = response.data.data.main_game_permission;
          this.listQuery.page = response.data.data.current_page;
      })
      .catch(error=>{})
    },
    copyLink(){
      this.$message.success("你已成功复制防沉迷链接");
    },
  },
  created() {
     let item = JSON.parse(this.$route.query.data)
     this.listQuery.id = item.id;
     this.viewHistory();
  },
   mounted() {
          this.$nextTick(() => {
            this.clipboard = new Clipboard('.link');
          })
    }
}
</script>
<style>
 .el-icon-circle-close:before {
    content: "\E78D";
    position:relative;
    right:300px;
    top:290px;
    background-color: white;
}
</style>